import * as yup from 'yup';

import { getValidateReferralCode } from 'src/api/userService/requests';
import { getTheme } from 'src/utils/getTheme';

import { referralCodeDataKeys } from './constants';

const { isHosTheme } = getTheme();

const errorMessages = {
    invalid: isHosTheme ? 'referral_code_invalid' : 'vita_collective_code_invalid',
};

export const referralCodeSchema = yup.object({
    [referralCodeDataKeys.referralCode]: yup
        .string()
        .test('referral-code-format', errorMessages.invalid, async (value) => {
            if (!value) return true;
            try {
                const response = await getValidateReferralCode(value);
                return response;
            } catch (error) {
                return false;
            }
        }),
});
